(()=> {
  const qs=(s,r=document)=>r.querySelector(s);

  const getPhoneFromEl = () => {
    const el = qs('[data-pd-wa-float]');
    if (!el) return '';
    return (el.getAttribute('data-pd-wa-phone') || '').replace(/\D/g,'');
  };

  const buildConciergeMessage = () => {
    const productRoot = qs('[data-main-product][data-product-title]');
    const title = productRoot ? (productRoot.getAttribute('data-product-title') || '').trim() : '';
    const url = window.location.href;
    if (title) return `Hello Maison Khatib, I would like assistance regarding: ${title} - ${url}`;
    return `Hello Maison Khatib, I would like assistance - ${url}`;
  };

  const openWhatsApp = (btn) => {
    if (window.PDWhatsApp && typeof window.PDWhatsApp.getHref === 'function') {
      const href = window.PDWhatsApp.getHref(btn);
      if (href) {
        window.open(href, '_blank', 'noopener');
        return;
      }
    }
    const phone = getPhoneFromEl() || (window.__PD_WA_PHONE || '').replace(/\D/g,'') || '96170664457';
    const msg = encodeURIComponent(buildConciergeMessage());
    const href = `https://wa.me/${phone}?text=${msg}`;
    window.open(href, '_blank', 'noopener');
  };

  document.addEventListener('click', (e)=>{
    const btn = e.target && e.target.closest ? e.target.closest('[data-pd-wa-float]') : null;
    if (!btn) return;
    e.preventDefault();
    openWhatsApp(btn);
  });
})();

(()=> {
  const canHover = window.matchMedia && window.matchMedia('(hover:hover) and (pointer:fine)').matches;
  if (!canHover) return;
  const items = Array.from(document.querySelectorAll('.nav .has-sub'));
  if (!items.length) return;
  const timers = new WeakMap();
  const clearClose = (item) => {
    const t = timers.get(item);
    if (t) window.clearTimeout(t);
    timers.delete(item);
  };
  const openItem = (item) => {
    clearClose(item);
    item.classList.add('is-open');
  };
  const scheduleClose = (item) => {
    clearClose(item);
    timers.set(item, window.setTimeout(() => {
      item.classList.remove('is-open');
      timers.delete(item);
    }, 750));
  };
  items.forEach((item) => {
    item.addEventListener('mouseenter', () => openItem(item));
    item.addEventListener('mouseleave', () => scheduleClose(item));
    item.addEventListener('focusin', () => openItem(item));
    item.addEventListener('focusout', () => {
      window.setTimeout(() => {
        if (!item.contains(document.activeElement)) scheduleClose(item);
      }, 0);
    });
    const submenu = item.querySelector('.sub');
    if (submenu) {
      submenu.addEventListener('mouseenter', () => openItem(item));
      submenu.addEventListener('mouseleave', () => scheduleClose(item));
    }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') items.forEach((item) => item.classList.remove('is-open'));
  });
})();
